<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row" v-if="userData.permissions['view_timesheets']==1">
  
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <!-- <div class="mb-2 float-end">
                <div><router-link to="/studentrollcall"><b-button size="sm" variant="info"><i class="mdi mdi-plus"></i> Record New Student Attendance</b-button></router-link></div>
            </div> -->
            <div class="row">
              <b-form-group class="col-md-3" label="Term">
                <v-select :options="schoolterms" placeholder="Select Term" v-model="schoolterm" label="name"></v-select>
              </b-form-group>
              <b-form-group class="col-md-2" label="Year">
                <v-select :options="years" placeholder="Select Year" v-model="year"></v-select>
              </b-form-group>
              <b-form-group class="col-md-3" label="Class">
                <v-select :options="schoolclasses" placeholder="Select Class" v-model="schoolclass" label="name"></v-select>
              </b-form-group>
              <div class="col-md-4 mt-md-4 mt-2 p-lg-0">
              <b-button variant="primary" @click="FilterData()"><i class="mdi mdi-account-search"></i> Filter</b-button>
            </div>
          </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
                <div class="text-center"><span class="text-center h4">{{ schoolclass.name }}  {{ year }} {{ schoolterm.name }}'s  Timesheet</span></div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(student_photo)="data">
                  <img :src="getFiles(data.item.student.student_photo)" height="50"/>
                </template>
                <template #cell(student_id)="data">
                  <b class="text-danger">{{ data.item.student.student_id }}</b> <br><small >Card No: <b style="color:green;">{{ data.item.student.cardnumber }}</b></small>
                </template>
                <template #cell(student)="data">
                  {{ data.item.student.first_name }} {{ data.item.student.last_name }}<br>
                  <small style="color:green;"> <b>{{ data.item.class[0].name}} {{ data.item.stream[0].name }} </b></small>
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>  
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
          </div>
        </div>
      </div>
    </div>    
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  // import Multiselect from "vue-multiselect";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import {  schoolclassComputed, schoolclassMethods,  schooltermComputed, schooltermMethods, } from "@/state/helpers";
  
  export default {
    page: {
      title: "Student Time Sheets ",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Student Time Sheets ",
        items: [ {text: "Dashboard",to: "/",}, {text: "Student Time Sheets ",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'student_photo', label: 'Photo ', visible: true },
            { key: 'student_id', label: 'Student ID', visible: true },
            { key: 'student', label: 'Student Name', visible: true },
            { key: 'present', label: 'Present ', visible: true },
            { key: 'absent', label: 'Absent', visible: true },
          ],
        id:'',schoolclass:'',schoolterm:'',student_id:'',student_photo:'',class:'',stream:'',
        student:'',present:'',absent:'',studentrecords:[],  cardnumber:'',
      year:new Date().getFullYear(),name:'',
      };
    },
    computed: {
      ...schoolclassComputed,
      ...schooltermComputed,
      List() { return this.studentrecords.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.studentrecords.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.studentrecords.length>0) { a=false;} else { a=true;} return a },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },
    },
    mounted() {
      this.fetchSchoolTerms();
      this.fetchSchoolClasses();
      //this.attendance();
      this.TotalRows = this.studentrecords.length;
      this.isBusy=false;
    },
    methods: {
      ...schooltermMethods,
      ...schoolclassMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      // async attendance(){
      //   let url = `/studenttimesheets`;
      //   await axios.get(url).then((response) => {
      //     this.studentrecords = response.data.studentrecords;
          
      //   });
      // },
      async FilterData(){
        let formData = new FormData();
        formData.append("schoolterm", this.schoolterm.id);
        formData.append("schoolclass", this.schoolclass.id);
        formData.append("year", this.year);
        let url = `/filtertimesheets`;
        await axios.post(url,formData).then((response) => {
          this.studentrecords = response.data.studentrecords;
        });
      },
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"students/"+name;
      return imagelink;
    },
    },
  };
  </script>